<style>
  .responsive {
    height: auto;
  }

  @media (max-width:768px) {
    .responsive {
      width: 100%;
    }
  }
</style>
<div class="container">
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-12 overflow-hidden">
      <div class="home-image-box">
        <img src="assets\img\14H06794_RF.jpg" />
      </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-12" style="padding-top: 10px;">
      <div class="panel-group" style="background: white;padding: 6px;">
        <div class="panel panel-default" id="panel4">
          <div class="panel-heading mt-2">
            <h4 class="panel-title">
              <a>
                <b>Contact Us</b>
              </a>
            </h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">

                <div style="padding-top: 5px;">
                  <div style="padding-bottom: 3px;"><span style="font-weight: bold;" target="_blank">For any query, please raise a service request on <a href="https://in-talentconnect.ey.net">Talent Help Desk</a> under Talent Systems</span><br></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
